import { render } from "./notWinning.vue?vue&type=template&id=85082a26&scoped=true"
import script from "./notWinning.vue?vue&type=script&lang=js"
export * from "./notWinning.vue?vue&type=script&lang=js"

import "./notWinning.vue?vue&type=style&index=0&id=85082a26&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85082a26"]])

export default __exports__